export const nativeOptions = [
  {
    value: 1,
    label: '是',
  },
  {
    value: 2,
    label: '否',
  },
]

export const statusOptions = [
  {
    value: 1,
    label: '显示',
  },
  {
    value: 2,
    label: '隐藏',
  },
]
